module.exports = __webpack_public_path__ + "img/whatsapp-btn.86138162.png";